import Helmet from "react-helmet"
import { FileText } from "lucide-react"
import "./LegalDocumentPage.css"

export interface LegalSection {
    title: string
    paragraphs: string[]
    bullets?: string[]
}

interface LegalDocumentPageProps {
    title: string
    subtitle: string
    canonicalPath: string
    sections: LegalSection[]
    note?: string
}

export default function LegalDocumentPage({ title, subtitle, canonicalPath, sections, note }: LegalDocumentPageProps) {
    return (
        <main className="legal-doc-page">
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={subtitle} />
                <link rel="canonical" href={`https://homeindex.ie${canonicalPath}`} />
            </Helmet>

            <div className="legal-doc-page__inner">
                <header className="legal-doc-page__header">
                    <span className="legal-doc-page__eyebrow">
                        <FileText size={14} strokeWidth={2} />
                        Legal
                    </span>
                    <h1 className="legal-doc-page__title">{title}</h1>
                    <p className="legal-doc-page__subtitle">{subtitle}</p>
                </header>

                <section className="legal-doc-page__grid" aria-label={title}>
                    {sections.map((section) => (
                        <article className="legal-doc-card" key={section.title}>
                            <h2 className="legal-doc-card__title">{section.title}</h2>
                            <div className="legal-doc-card__body">
                                {section.paragraphs.map((paragraph) => (
                                    <p key={paragraph}>{paragraph}</p>
                                ))}
                                {section.bullets && (
                                    <ul>
                                        {section.bullets.map((bullet) => (
                                            <li key={bullet}>{bullet}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </article>
                    ))}
                </section>

                {note && <div className="legal-doc-page__note">{note}</div>}
            </div>
        </main>
    )
}
